import {HomeComponent} from './borrow/home/home.component';
import {TeamComponent} from './team/team.component';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {TermsComponent} from './terms/terms.component';
import {ProfileComponent} from './profile/profile.component';
import {InvestComponent} from './invest/home/invest.component';
import {NotFoundComponent} from './notfound/notfound.component';
import {RegisterComponent} from './register/register.component';
import {ReferralsComponent} from './referrals/referrals.component';
import {ContactusComponent} from './contactus/contactus.component';
import {LoandetailComponent} from './loandetail/loandetail.component';
import {PartnerfaqComponent} from './partnerfaq/partnerfaq.component';
import {PeerToPeerComponent} from './articles/peer-to-peer.component';
import {LenderintroComponent} from './lenderintro/lenderintro.component';
import {PartnertermsComponent} from './partnerterms/partnerterms.component';
import {PanBackLinkResolver} from './pan-verification/pan-back-link.resolver';
import {PrivacypolicyComponent} from './privacypolicy/privacypolicy.component';
import {LendersummaryComponent} from './lendersummary/lendersummary.component';
import {LenderinitialComponent} from './lenderinitial/lenderinitial.component';
import {LenderconsentComponent} from './lenderconsent/lenderconsent.component';
import {LenderpassbookComponent} from './lenderpassbook/lenderpassbook.component';
import {InvestorwalletComponent} from './investorwallet/investorwallet.component';
import {PanInformationResolver} from './pan-verification/pan-information.resolver';
import {ChannelPartnerIdResolver} from './borrow/home/channel-partner-id.resolver';
import {PhoneVerificationGuard} from './phoneverification/phone-verification.guard';
import {LenderPersonalInfoGuard} from './residence-info/lender-personal-info.guard';
import {FinzyGetsCertificateComponent} from './articles/finzy-gets-certificate.component';
import {ResidenceInfoLinksResolver} from './residence-info/residence-info-links.resolver';
import {InvestordashboardComponent} from './investordashboard/investordashboard.component';
import {LenderResidenceInfoResolver} from './residence-info/lender-residence-info.resolver';
import {LenderpersonalinfoComponent} from './lenderpersonalinfo/lenderpersonalinfo.component';
import {ManualinvestdetailComponent} from './portfolio-creation/manualinvestdetail/manualinvestdetail.component';
import {LenderBankDetailsComponent} from './lender-bank-details/lender-bank-details.component';
import {RegistrationsuccessComponent} from './registrationsuccess/registrationsuccess.component';
import {InterestCertificateComponent} from './interest-certificate/interest-certificate.component';
import {ApplicationFlowType, ResidenceInfoComponent} from './residence-info/residence-info.component';
import {LenderuploaddocumentsComponent} from './lenderuploaddocuments/lenderuploaddocuments.component';
import {PortfolioCreationGuard} from './portfolio-creation/guards/portfolio-creation.guard';
import {InvestmentApplicationPanVerificationComponent} from './pan-verification/pan-verification.component';
import {
    AuthGuard,
    BorrowerObstructGuard,
    BorrowGuard,
    LenderGuard,
    LenderObstructGuard,
    NewUserObstructGuard
} from './auth.guard';
import {LenderPhoneVerificationComponent} from './lenderphoneverification/lender-phone-verification.component';
import {InvestmentApplicationFlowComponent} from './views/investors/investment-application-flow/investment-application-flow.component';
import {CampaignComponent} from './invest/campaign/campaign.component';
import {ReferralConsentComponent} from './referral-consent/referral-consent.component';
import {ReferralConsentResolver} from './referral-consent/referral-consent.resolver';
import {BorrowerCampaignComponent} from './borrow/borrower-campaign/borrower-campaign.component';
import {OnlyUsersWithoutLoanGuard} from './guards/only-users-without-loan.guard';
import {IfaCampaignComponent} from './ifa/ifa-campaign/ifa-campaign.component';
import {ChannelPartnerResolver} from './borrow/eligibility-check/eligibility-check-form/channel-partner.resolver';
import {LoanMaturedComponent} from './loan-matured/loan-matured.component';
import {InvitationResolver} from './views/accept-invitation/invitation.resolver';
import {PanVerificationStatusResolver} from './views/accept-invitation/pan-verification-status.resolver';
import {AcceptInvitationComponent} from './views/accept-invitation/accept-invitation.component';
import {InvestmentApplicationEmailVerificationComponent} from './email-verification/email-verification.component';
import {AutoInvestGuard} from './portfolio-creation/auto-invest/guards/auto-invest.guard';
import {InvestorAllocatedLoansPath, PreferencesPath} from './navigation/routes';
import {OnlyBorrowerApplicantsGuard} from './guards/only-borrower-applicants.guard';
import {OnlyBorrowerApplicantsInProgressGuard} from './guards/only-borrower-applicants-in-progress.guard';
import {ActiveApplicationValidationGuard} from './guards/active-application-validation.guard';
import {NoOpComponent} from './no-op.component';
import {ChannelPartnerLogoResolver} from './borrow/home/channel-partner-logo.resolver';
import {OnlyUsersWithoutLoanApplicationGuard} from './guards/only-users-without-loan-application.guard';
import {LenderNomineeComponent} from './lender-nominee/lender-nominee.component';
import {LenderDashboardNomineeComponent} from './profile/lender-dashboard-nominee/lender-dashboard-nominee.component';
import {InvestmentPreferencesComponent} from './views/investors/investment-application-flow/steps/investment-preferences/investment-preferences.component';
import {InvestmentPreferencesResolver} from './resolvers/investment-preferences.resolver';
import {BorrowerPhoneNumberVerificationResolver} from './borrow/borrower-phone-number-verification/borrower-phone-number-verification.resolver';
import {ChannelPartnerTransactionIdResolver} from './borrow/home/channel-partner-transaction-id.resolver';
import {InvestorRelationsComponent} from './investor-relations/investor-relations.component';
import { UserAttributeResolver } from './views/investors/finzy-flex/user-attribute/user-attribute.resolver';
import { ProductResolver } from './resolvers/product.resolver';

const APP_ROUTES: Routes = [
    {path: '', pathMatch: 'full', redirectTo: 'borrow'},
    {
        path: 'borrow',
        component: HomeComponent,
        canActivate: [BorrowGuard, OnlyUsersWithoutLoanApplicationGuard], // CanApply redirects if any application by borrower is pending, or loan is in orderedStatus for.
        // If there are no applications or he can reapply - allow.
        resolve: {
            channelPartnerInformation: ChannelPartnerIdResolver,
            partnerLogoUrl: ChannelPartnerLogoResolver,
            partnerTransactionId: ChannelPartnerTransactionIdResolver
        }
    },

    {
        path: 'cibil/check-user-details',
        loadChildren: () => import('./borrow/cibil-check/user-details.module').then(m => m.UserDetailsModule)
    },

    {path: 'login', component: LoginComponent},

    {path: 'register', component: RegisterComponent},

    {path: 'registrationsuccess/:id', component: RegistrationsuccessComponent},

    {
        path: 'invest', component: InvestComponent,
        canActivate: [LenderGuard],
    },
    {
        path: 'invest/campaign',
        component: CampaignComponent,
        canActivate: [LenderGuard, NewUserObstructGuard]
    },

    {path: 'team', component: TeamComponent},
    {
        path: 'borrow/campaign',
        component: BorrowerCampaignComponent,
        canActivate: [BorrowGuard, NewUserObstructGuard]
    },
    {
        path: 'invest', component: InvestmentApplicationFlowComponent,
        children: [{
            path: 'pan-verification',
            component: InvestmentApplicationPanVerificationComponent,
            canActivate: [LenderGuard],
            resolve: {
                panInformation: PanInformationResolver,
                backLink: PanBackLinkResolver
            }
        }, {
            path: 'email-verification',
            component: InvestmentApplicationEmailVerificationComponent,
            canActivate: [AuthGuard, BorrowerObstructGuard],
        }, {
            path: 'residence-info',
            component: ResidenceInfoComponent,
            data: {
                applicationFlowType: ApplicationFlowType.LenderApplicationFlow
            },
            resolve: {
                residenceInformation: LenderResidenceInfoResolver,
                links: ResidenceInfoLinksResolver
            },
            canActivate: [AuthGuard, LenderPersonalInfoGuard]
        }, {
            path: 'lender-nominee',
            component: LenderNomineeComponent,
            canActivate: [AuthGuard]
        }, {
            path: 'investment-preferences',
            component: InvestmentPreferencesComponent,
            resolve: {
                investmentPreferences: InvestmentPreferencesResolver,
                userAttributes: UserAttributeResolver,
                product: ProductResolver
            },
            canActivate: [AuthGuard]
        }]
    },
    {
        path: 'invitation/:id',
        component: AcceptInvitationComponent,
        resolve: {
            invitationDetails: InvitationResolver,
            panVerificationResult: PanVerificationStatusResolver
        }
    },
    {
        path: 'invest/phone-verification',
        component: LenderPhoneVerificationComponent,
        canActivate: [PhoneVerificationGuard],
    },
    {
        // Deprecated path - To be removed a short while after first phoenix release.
        path: 'loanprogress',
        redirectTo: 'borrow/dashboard/applications'
    },

    {
        // Deprecated path - To be removed a short while after first phoenix release.
        path: 'borrowerdashboard',
        redirectTo: 'borrow/dashboard/applications'
    },

    {
        // Deprecated path - To be removed a short while after first phoenix release.
        path: 'passbook',
        redirectTo: 'borrow/dashboard/applications',
    },

    {
        path: 'referrals', component: ReferralsComponent,
        canActivate: [AuthGuard]
    },

    {
        path: 'manualinvestdetail', component: ManualinvestdetailComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard]
    },

    {
        path: 'borrow/eligibility-check',
        loadChildren: () => import('./borrow/eligibility-check/eligibility-check.module').then(m => m.EligibilityCheckModule),
        canActivate: [OnlyUsersWithoutLoanGuard],
        resolve: {
            channelPartner: ChannelPartnerResolver
        }
    },

    {
        path: 'manual-invest/:tempPortfolioId',
        canActivate: [PortfolioCreationGuard],
        loadChildren: () => import('./portfolio-creation/manualinvest/manual-invest.module').then(m => m.ManualInvestModule)
    },
    // TODO - Remove usages of 'autoinvest' route
    {
        path: 'autoinvest',
        redirectTo: 'auto-invest'
    },
    {
        path: 'borrow',
        children: [{
            path: 'application/:applicationId',
            canActivate: [ActiveApplicationValidationGuard],
            component: NoOpComponent
        }, {
            path: '',
            loadChildren: () => import('./loan-application-flow-component/loan-application-flow.module').then(m => m.LoanApplicationFlowModule),
            canActivate: [OnlyBorrowerApplicantsInProgressGuard]
        }, {
            path: 'application/:id/status',
            loadChildren: () => import('./borrow/application-status/application-status.module').then(m => m.ApplicationStatusModule),
            canActivate: [OnlyBorrowerApplicantsGuard]
        }, {
            path: 'dashboard',
            loadChildren: () => import('./borrow/borrower-dashboard/borrower-dashboard.module').then(m => m.BorrowerDashboardModule),
            canActivate: [AuthGuard]
        }, {
            path: 'phone-number/verification',
            loadChildren: () => import('./borrow/borrower-phone-number-verification/borrower-phone-number-verification.module').then(m => m.BorrowerPhoneNumberVerificationModule),
            resolve: {user: BorrowerPhoneNumberVerificationResolver}
        },
        {
            path: 'cibil-dashboard',
            loadChildren: () => import('./borrow/cibil-dashboard/cibil-dashboard.module').then(m => m.CibilDashboardModule),
            canActivate: [AuthGuard]
        }],
    },
    {
        path: 'auto-invest/:tempPortfolioId',
        loadChildren: () => import('./portfolio-creation/auto-invest/auto-invest.module').then(m => m.AutoInvestModule),
        canActivate: [AuthGuard, BorrowerObstructGuard, AutoInvestGuard, PortfolioCreationGuard]
    },
    {
        path: 'investordashboard', component: InvestordashboardComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },

    {
        path: 'lenderinitial', component: LenderinitialComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },

    {
        path: 'portfoliodetail/:id',
        loadChildren: () => import('./portfolio-detail/portfolio-detail.module').then(m => m.PortfolioDetailModule),
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },

    {
        path: 'loandetail/:id', component: LoandetailComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },
    {
        // Deprecated path - To be removed a short while after first phoenix release.
        path: 'loansanction',
        redirectTo: 'borrow/dashboard/applications'
    },
    {
        // Deprecated path - To be removed a short while after first phoenix release.
        path: 'loanSanction',
        redirectTo: 'borrow/dashboard/applications'
    },
    {
        path: 'lenderpassbook', component: LenderpassbookComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },

    {
        path: 'investorwallet', component: InvestorwalletComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },

    {
        path: 'lenderconsent', component: LenderconsentComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },
    {
        path: 'interest-certificate', component: InterestCertificateComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },
    {
        canActivate: [AuthGuard, BorrowerObstructGuard],
        path: PreferencesPath,
        loadChildren: () => import('./preferences/preferences.module').then(m => m.PreferencesModule)
    },
    {
        path: 'provisional-certificate',
        redirectTo: 'interest-certificate',
        pathMatch: 'full'
    },
    {
        path: 'lenderintro', component: LenderintroComponent,
        canActivate: [LenderGuard]
    },
    {
        path: 'invest/referral-consent', component: ReferralConsentComponent,
        resolve: {
            name: ReferralConsentResolver
        },
        canActivate: [LenderGuard]
    },
    {
        path: 'lenderbankdetails', component: LenderBankDetailsComponent,
        canActivate: [AuthGuard, LenderGuard, BorrowerObstructGuard]
    },

    {
        path: 'lenderuploaddocuments', component: LenderuploaddocumentsComponent,
        canActivate: [AuthGuard, LenderGuard, BorrowerObstructGuard]
    },

    {
        path: 'lendersummary', component: LendersummaryComponent,
        canActivate: [AuthGuard, LenderGuard, BorrowerObstructGuard],
    },

    {
        path: 'lenderpersonalinfo', component: LenderpersonalinfoComponent,
        canActivate: [AuthGuard, LenderGuard, BorrowerObstructGuard],
    },

    {
        path: 'profile', component: ProfileComponent,
        canActivate: [AuthGuard]
    },

    {
        path: 'nominee', component: LenderDashboardNomineeComponent,
        canActivate: [AuthGuard]
    },

    {
        path: 'articles/peer-to-peer-lending', component: PeerToPeerComponent
    },

    {
        path: 'articles/finzy-gets-nbfc-p2p-certificate', component: FinzyGetsCertificateComponent
    },

    {path: 'terms', component: TermsComponent},

    {path: 'partnerterms', component: PartnertermsComponent},

    {path: 'partnerfaq', component: PartnerfaqComponent},

    {
        path: 'faq',
        loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule)
    },

    {path: 'privacypolicy', component: PrivacypolicyComponent},

    {path: 'ifa/campaign', component: IfaCampaignComponent},

    {path: 'partnerwithus', component: IfaCampaignComponent},

    {path: 'contactus', component: ContactusComponent},
    {path: 'investor-relations', component: InvestorRelationsComponent},
    {
        path: 'lender/:lenderId/delayed-loans',
        loadChildren: () => import('./lender-delayed-loans/lender-delayed-loans.module').then(m => m.LenderDelayedLoansModule),
        canActivate: [AuthGuard, BorrowerObstructGuard],
    }, {
        path: InvestorAllocatedLoansPath,
        loadChildren: () => import('./views/investors/investor-loans/investor-loans.module').then(m => m.InvestorLoansModule),
        canActivate: [AuthGuard, BorrowerObstructGuard]
    },
    {
        path: 'loan-matured', component: LoanMaturedComponent,
        canActivate: [AuthGuard, LenderObstructGuard]
    },
    {
        path: 'recently-filled-loans',
        loadChildren: () => import('./views/investors/investor-commons/investor-commons.module').then(m => m.InvestorCommonsModule),
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },
    {
        path: 'investments',
        loadChildren: () => import('./views/investors/investments/investments.module').then(m => m.InvestmentsModule),
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },

    {
        path: 'payment',
        loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'link-payments',
        loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule),
    },
    {
        path: 'investment-initial',
        loadChildren: () => import('./views/investors/finzy-flex/investment-initial/investment-initial.module').then(m => m.InvestmentInitialModule),
        canActivate: [AuthGuard, BorrowerObstructGuard],
    },
    {
        path: 'finzy-flex',
        loadChildren: () => import('./views/investors/finzy-flex/flex-home/flex-home.module').then(m => m.FlexHomeModule),
    },
    {path: '**', component: NotFoundComponent}];

export const APP_ROUTES_PROVIDER = RouterModule.forRoot(APP_ROUTES, {scrollPositionRestoration: 'enabled'});
